import { t } from 'i18next';
import { useDispatch, useSelector } from 'react-redux';
import { MainButton } from '../../../components/Buttons/MainButton';
import { setAccountSettingsModals } from '../../../redux/accountSettingsPage/accountSettingsSlice';
import { RootState } from '../../../redux/store';
import { colors } from '../../../theme/colors';
import { fontSize } from '../../../theme/typography';
import {
  accountSettingsCardFieldStyles,
  fieldRowStyles,
  settingTitleStyles,
} from './styles';

const AccountSettingsNameField = () => {
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.user);

  const openNameEditModal = () => {
    dispatch(setAccountSettingsModals({ isNameEditModalOpen: true }));
  };

  return (
    <div style={accountSettingsCardFieldStyles}>
      <div style={fieldRowStyles.row}>
        <div
          style={{
            ...fieldRowStyles.infoContainer,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <div style={settingTitleStyles}>{t('accountSettings.name')}</div>
          <div
            style={{
              color: colors.textGreyMedium,
              fontSize: fontSize.sm,
              flexShrink: 1,
              overflow: 'hidden',
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              wordBreak: 'break-word',
            }}
          >
            {user?.name}
          </div>
        </div>
        <MainButton
          onClick={openNameEditModal}
          variant="outlined"
          size="small"
          typeStyle="secondary"
          text={t('common.edit')}
          style={{
            marginLeft: 12,
            flexShrink: 0,
          }}
        />
      </div>
    </div>
  );
};

export default AccountSettingsNameField;
